import React from 'react';
import PropTypes from 'prop-types';

const ContentBlockWidget = ({ uiSchema }) => {
  const hasContent =
    uiSchema['ui:content'] === null ||
    uiSchema['ui:content'].replace(/(<h1>)(<br>)(<\/h1>)/gim, '') !== '';
  return (
    <div>
      {hasContent && <div
        style={{ wordBreak: 'break-word' }}
        dangerouslySetInnerHTML={{ __html: uiSchema['ui:content'] }}
      />}
    </div>
  );
};

ContentBlockWidget.propTypes = {
  uiSchema: PropTypes.object.isRequired
};

export default ContentBlockWidget;



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Widgets/ContentBlock.js